import { combineReducers } from 'redux';

import * as actionTypes from '@store/favourite/action-types';

const onGetTotalCount = (state = 0, { type, payload }) => {
	switch (type) {
		case actionTypes.TOTAL_FAVOURITE_UNSEEN_COUNT:
			return payload;
		default:
			return state;
	}
};

const initialStateFroProducts = {
	data: [],
	currentPage: 0,
	totalPages: 1
};

const getFavouriteProducts = (state = initialStateFroProducts, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FAVOURITE_PRODUCT_LIST_FAILURE:
			return state;
		case actionTypes.FETCH_FAVOURITE_PRODUCT_LIST_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_FAVOURITE_PRODUCT_LIST_MORE_SUCCESS:
			return {
				...state,
				...payload,
				data: [...state.data, ...payload.data]
			};
		default:
			return state;
	}
};

const initialStateFroMaterials = {
	data: [],
	currentPage: 0,
	totalPages: 1
};
const getFavouriteMaterials = (state = initialStateFroMaterials, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FAVOURITE_MATERIAL_LIST_FAILURE:
			return state;
		case actionTypes.FETCH_FAVOURITE_MATERIAL_LIST_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_FAVOURITE_MATERIAL_LIST_MORE_SUCCESS:
			return {
				...state,
				...payload,
				data: [...state.data, ...payload.data]
			};
		default:
			return state;
	}
};

const initialStateForFolders = {
	folders: [],
	currentPage: 0,
	totalPages: 1
};

const getFavouriteFolders = (state = initialStateForFolders, { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_FAVOURITE_FOLDER_LIST_SUCCESS:
			return {
				...payload
			};
		case actionTypes.FETCH_FAVOURITE_FOLDER_LIST_MORE_SUCCESS:
			return {
				...state,
				...payload,
				folders: [...state.folders, ...payload.folders]
			};
		default:
			return state;
	}
};

const initialStateForFavouritePageTab = {
	code: 'DESIGN',
	title: 'Design'
};

const favouritePageTab = (state = initialStateForFavouritePageTab, { type, payload }) => {
	switch (type) {
		case actionTypes.SET_ACTIVE_FAVOURITE_PAGE_TAB:
			return payload;
		default:
			return state;
	}
};

const favouriteReducer = combineReducers({
	totalFavouriteCount: onGetTotalCount,
	favouriteProducts: getFavouriteProducts,
	favouriteMaterials: getFavouriteMaterials,
	favouriteFolders: getFavouriteFolders,
	favouritePageTab: favouritePageTab
});

export default favouriteReducer;
